// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__Tghd8","logo":"css_logo__A+cI3","title":"css_title__RkoiK","text":"css_text__rItYL"};